export const getInitials = name => {
  const splitNames = name
    .split(/(\s+)/)
    .filter(word => word.length > 1)
    .map(word => word.charAt(0));

  return splitNames.join('');
};
